import { NgModule, Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, ViewChild, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { DEVICE_INFO, APP_SETTINGS, DeviceInfo, MediaStream } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'social-icons',
    templateUrl: "social-icons.template.html",
    styleUrls: [`./social-icons.style.scss`],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialIcons {
    @Input() titlebar : boolean;
    @Input() item: any;
    @Input() hoverBack: boolean;
    @Input() isShare: boolean = false;
    @Input() isVideo: boolean  =false;
    @Input() config: any;
    @Input() media: any;
    @Input() expanded : boolean = false;

    @Input() isActive: boolean;
    @ViewChild("twitter") twitterBtn;
    @ViewChild("facebook") facebookBtn;

    private target: any;
    private via: string;
    private twitterURI: string = "https://twitter.com/intent/tweet"
    private facebookURI:string = "https://www.facebook.com/sharer/sharer.php";
    private isServer : boolean;
    private eventSubscription: Subscription;
    constructor(
        @Inject(PLATFORM_ID) platformId: string,
        @Inject(APP_SETTINGS) settings: any,
        private interactions: EventInteraction,
        private cd : ChangeDetectorRef

    ){
        this.isServer = isPlatformServer(platformId);
        this.via = settings.TWITTER_SITE;
    }


   private get hasVideo(): boolean{
     let objtype:string =  this.item.obj_type ? this.item.obj_type.toLocaleLowerCase() : null;

     if (!objtype) {
       return false;
     }

     if (objtype != "video" && objtype != "episode") {
       return false;
     }

     if (objtype == "video" && this.item.youtube_id) {
       return false;
     }

     if (
       objtype == "episode"
       && this.item.video
       && this.item.video.meta
       && this.item.video.meta.youtube_id
     ) {
       return false;
     }

     return true;
    }

    ngOnInit(){
        this.eventSubscription = this.interactions.subscribe((e) => {

            if (e.key == "openSocialShare"){

                this.isActive = true;

            }
            else if(e.key == "closeSocialShare")
            {
                this.isActive = false;
            }

            this.cd.detectChanges();
        })
    }

    ngOnDestroy(){
        if (this.eventSubscription){
            this.eventSubscription.unsubscribe();
        }
    }

    ngAfterViewInit(){
        this.cd.detectChanges();
    }
    private get location():string{
        let loc:string;
        if(!this.isServer){
            loc = window.location.href;

            if(loc.indexOf('embed') != -1)
            {
                loc = loc.replace('/embed/', '/');
            }

        }else {
            loc="";
        }

        return loc;
    }
    private buildHref(button: string){
        let url : string = "";
        let site: string = "";
        let desc: string = "";

        if(!this.isServer){
            let location = window.location.href;

            if(location.indexOf('embed') != -1)
            {
                location = location.replace('/embed/', '/');
            }

            switch( button ){
                case "twitter":
                    url = this.twitterURI + "?url=" + location + "&via=" + this.via + "&text=" + encodeURI(this.item.title);
                break
                case "facebook":
                     url = this.facebookURI + "?u=" + encodeURI(location);
                break
            }
            return url;
        }
    }

    toggleEmbed(event) {
        if (this.item && this.item.slug) {
            var msg:any = { slug: this.item.slug};
            this.interactions.next({ key: "toggleVideoEmbedShare", message: msg})
        }
    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/social-icons/social-icons.component.ts